import { render, staticRenderFns } from "./WithdrawItem.vue?vue&type=template&id=34ef6e80&scoped=true"
import script from "./WithdrawItem.vue?vue&type=script&lang=js"
export * from "./WithdrawItem.vue?vue&type=script&lang=js"
import style0 from "./WithdrawItem.vue?vue&type=style&index=0&id=34ef6e80&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ef6e80",
  null
  
)

export default component.exports